module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-checkbox-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-ecc31b5e"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/checkbox/src/checkbox-group.vue
// module id = 286
// module chunks = 0